import { useHistory } from 'react-router-dom'
import noImage from '../../assets/img/no-image.png'
import { setCurrentEntidade } from '../../provider/actions'
import { useProvider } from '../../provider/Provider'
import { Item } from './style'
import { Entidade } from '../../model/Entidade'

export default function EntidadeItem(props: {ent: Entidade}) {
    const { ent } = props
    const history = useHistory()
    const { dispatch } = useProvider()

    const onClickLink = (e: any) => {
        e.preventDefault()
        setCurrentEntidade(dispatch, ent)
        history.push(`/visualizar/${ent.id}`)
    }

    return (
        <div className="col-md-4 p-0">
            <Item>
                <button
                    className="item-header"
                    onClick={onClickLink}
                >
                    <img src={ent.logo || noImage} alt="Logo" />
                </button>
                <div className="item-content">
                    <span>{ent.nome}</span>
                    <p className="description">
                        {ent.descricao}
                    </p>
                    <div className="tags">
                        {
                            ent.tipoEntidade.map((a) => {
                                return (
                                    <span key={a.id}>
                                        <i className="fas fa-tag fa-sm mr-1" />
                                        {a.nome}
                                    </span>
                                )
                            })
                        }
                    </div>
                </div>
                <button
                    className="item-footer"
                    onClick={onClickLink}
                >
                    <span>Ver Perfil</span>
                    <i className="fas
                    fa-angle-right ml-2"
                    />
                </button>
            </Item>
        </div>
    )
}
